import { useDispatch } from 'react-redux';

export const useAction = (action) => {
  const dispatch = useDispatch();
  return (payload) => dispatch(action(payload));
};
